export class ProfileTwofactorDTO {

    status: boolean;

    secret: string;

    email: string;

}
